import type { AssetsBatchEditProps } from "./assets-batch-edit.type";

import BatchEditSelect from "@/modules/batch-edit-select";

import { AssetsBatchEditContent } from "./assets-batch-edit-content";
import { useAssetsBatchEditProperties } from "./assets-batch-edit.hook";

export const AssetsBatchEdit = ({ assets }: AssetsBatchEditProps) => {
  const { properties, currentProperty, setCurrentProperty } =
    useAssetsBatchEditProperties(assets);

  const subType = assets[0]?.asset_id ? "component" : "asset";

  return (
    <div className="assets-batch-edit">
      <BatchEditSelect
        type="asset"
        subType={subType}
        items={assets}
        properties={properties}
        onPropertyChange={setCurrentProperty}
      />
      <AssetsBatchEditContent property={currentProperty} assets={assets} />
    </div>
  );
};
